$(function() {

  var request;

  $('#search-link').on('click', function(e) {
    e.preventDefault();
    $('#search-form').toggleClass('active');
    $('#search-results').toggleClass('active');
    if($('#search-form').hasClass('active')) {
      $('#search-field').trigger('focus');
    }
  });

  $('#search-close-icon').on('click', function(e) {
    e.preventDefault();
    $('#search-form').toggleClass('active');
    $('#search-results').toggleClass('active');
    $('#search-field').val('');
    $('#search-results').empty();
  });

  $(document).mouseup(function(e)
  {
      var container = $(".search-feature");

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0)
      {
        $('#search-form').removeClass('active');
        $('#search-results').removeClass('active');
        $('#search-field').val('');
        $('#search-results').empty();
      }
  });

  $('#search-field').on('input', function() {
    var search = $(this).val().toLowerCase();
    var $results = $('#search-results');
    if(search.length > 3) {
      if(request) {
        request.abort();
        request = null;
      }
      request = $.getJSON('/search/json', {
        query: search
      }, function(data) {
        $results.empty();
        var results = data.products;
        if(results.length > 0) {
          results.forEach(function(item) {
            var $result = $('<li><a class="search-link" href="' + item.url + '">' + item.model + '</a></li>');
            $results.append($result);
            $('.search-link').on('click', function(e) {
              e.stopPropagation();
              $('#search-form').removeClass('active');
              $('#search-results').removeClass('active');
              $('#search-field').val('');
              $('#search-results').empty();
            });

          });
        } else {
          $results.append('<p>No matching results</p>');
        }
      }).done(function() {
        request = null;
      });
    } else {
      if(request) {
        request.abort();
        request = null;
      }
      $results.empty();
    }
  });

});



// WEBPACK FOOTER //
// ./assets/js/search.js